module.exports = __webpack_public_path__ + "static/media/logoCampanha.c2e9c456.jpg";